// Common countries + full province / state lists for the ContactDialog
// location fields. Country is a searchable combobox with a stable preset
// order; states/provinces are auto-filtered based on the picked country.

export const COUNTRY_LIST = [
  { code: "GB", name: "United Kingdom" },
  { code: "CA", name: "Canada" },
  { code: "US", name: "United States" },
  { code: "IE", name: "Ireland" },
  { code: "AU", name: "Australia" },
  { code: "NZ", name: "New Zealand" },
  { code: "DE", name: "Germany" },
  { code: "FR", name: "France" },
  { code: "ES", name: "Spain" },
  { code: "IT", name: "Italy" },
  { code: "NL", name: "Netherlands" },
  { code: "BE", name: "Belgium" },
  { code: "PT", name: "Portugal" },
  { code: "SE", name: "Sweden" },
  { code: "NO", name: "Norway" },
  { code: "DK", name: "Denmark" },
  { code: "FI", name: "Finland" },
  { code: "PL", name: "Poland" },
  { code: "AT", name: "Austria" },
  { code: "CH", name: "Switzerland" },
  { code: "MX", name: "Mexico" },
  { code: "BR", name: "Brazil" },
  { code: "AR", name: "Argentina" },
  { code: "JP", name: "Japan" },
  { code: "KR", name: "South Korea" },
  { code: "CN", name: "China" },
  { code: "IN", name: "India" },
  { code: "SG", name: "Singapore" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "ZA", name: "South Africa" },
];

export const CA_PROVINCES = [
  "Alberta",
  "British Columbia",
  "Manitoba",
  "New Brunswick",
  "Newfoundland and Labrador",
  "Northwest Territories",
  "Nova Scotia",
  "Nunavut",
  "Ontario",
  "Prince Edward Island",
  "Quebec",
  "Saskatchewan",
  "Yukon",
];

export const US_STATES = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado",
  "Connecticut", "Delaware", "District of Columbia", "Florida", "Georgia",
  "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky",
  "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota",
  "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire",
  "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota",
  "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island",
  "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont",
  "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming",
];

export function regionLabelForCountry(country) {
  const c = (country || "").toLowerCase();
  if (c === "canada") return "Province";
  if (c === "united states" || c === "usa" || c === "united states of america")
    return "State";
  return "State / Province / Region";
}

export function regionOptionsForCountry(country) {
  const c = (country || "").toLowerCase();
  if (c === "canada") return CA_PROVINCES;
  if (c === "united states" || c === "usa" || c === "united states of america")
    return US_STATES;
  return null; // caller falls back to free text
}

/** Best-effort default country from the browser locale. */
export function guessDefaultCountry() {
  try {
    const lang = (navigator.language || "en-GB").toUpperCase();
    if (lang.endsWith("-CA")) return "Canada";
    if (lang.endsWith("-US")) return "United States";
    if (lang.endsWith("-GB")) return "United Kingdom";
    if (lang.endsWith("-AU")) return "Australia";
    if (lang.endsWith("-IE")) return "Ireland";
  } catch {
    /* noop */
  }
  return "";
}
